import { render, staticRenderFns } from "./EmptyGraphMessage.html?vue&type=template&id=246046f7&external"
var script = {}
import style0 from "./EmptyGraphMessage.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports